export default "__VITE_ASSET__I8Jjw7cj__"